import { render, staticRenderFns } from "./NewPublicTaskForm.vue?vue&type=template&id=cfbf61a6&scoped=true&"
import script from "./NewPublicTaskForm.vue?vue&type=script&lang=ts&"
export * from "./NewPublicTaskForm.vue?vue&type=script&lang=ts&"
import style0 from "./NewPublicTaskForm.vue?vue&type=style&index=0&id=cfbf61a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfbf61a6",
  null
  
)

export default component.exports